@defer (on viewport) {
  <app-card>
    <app-card-header title="Financeiro" />
    <div class="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-4">
      <div class="p-3 h-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-7 gap-4 col-span-1 md:col-span-2 2xl:col-span-4">
        @if (financialDepositAndWithdrawMetricsLoading()) {
          @for (item of [0,1,2,3,4,5, 6]; track item) {
            <p-skeleton height="6rem" />
          }
        }
        @else {
          <ng-container
            [ngTemplateOutlet]="financialMetrics"
            [ngTemplateOutletContext]="{ inDialog: false }"
          ></ng-container>
        }
      </div>
      <div class="p-3 h-full border border-zinc-300 rounded-lg col-span-1">
        <ng-container
          [ngTemplateOutlet]="financialInOut"
          [ngTemplateOutletContext]="{ inDialog: false }"
        ></ng-container>
      </div>
      <div class="p-3 h-full border border-zinc-300 rounded-lg col-span-1">
        <ng-container
          [ngTemplateOutlet]="financialByCategory"
          [ngTemplateOutletContext]="{ inDialog: false }"
        ></ng-container>
      </div>
      <div class="p-3 h-full border border-zinc-300 rounded-lg col-span-1">
        <ng-container
          [ngTemplateOutlet]="financialInvoices"
          [ngTemplateOutletContext]="{ inDialog: false }"
        ></ng-container>
      </div>
      <div class="p-3 h-full border border-zinc-300 rounded-lg col-span-1">
        <ng-container
          [ngTemplateOutlet]="financialProfitExpenses"
          [ngTemplateOutletContext]="{ inDialog: false }"
        ></ng-container>
      </div>
      <!-- <div class="p-3 h-full border border-zinc-300 rounded-lg space-y-4">
        <div class="flex flex-wrap items-start justify-between">
          <div class="text-zinc-800 text-sm">Contas Bancárias</div>
          <div></div>
        </div>
        <div class="w-full flex flex-col gap-4">
          <div class="w-full flex flex-col items-start justify-start gap-4">
            <div class="w-full flex items-center justify-between">
              <div class="text-xl font-semibold text-zinc-900">Conta 1</div>
              <div class="font-semibold text-blue-400">94 pendentes</div>
            </div>
            <div class="w-full grid grid-cols-2">
              <div class="w-full flex items-center justify-between">
                <div class="text-zinc-700">Saldo na conta</div>
                <div class="text-zinc-900 font-semibold">{{ 12345.62 | currency }}</div>
              </div>
              <div class="w-full flex justify-end text-zinc-500 text-sm">
                Atualizado
              </div>
              <div class="w-full flex items-center justify-between">
                <div class="text-zinc-700">Saldo no sistema</div>
                <div class="text-zinc-900 font-semibold">{{ 4987.43 | currency }}</div>
              </div>
              <div class="w-full flex justify-end text-zinc-500 text-sm">
                4 dias atras
              </div>
            </div>
          </div>
          <p-divider />
          <div class="w-full flex flex-col items-start justify-start gap-4">
            <div class="w-full flex items-center justify-between">
              <div class="text-xl font-semibold text-zinc-900">Conta 2</div>
              <div class="font-semibold text-blue-400">94 pendentes</div>
            </div>
            <div class="w-full grid grid-cols-2">
              <div class="w-full flex items-center justify-between">
                <div classright="text-zinc-700">Saldo na conta</div>
                <div class="text-zinc-900 font-semibold">{{ 12345.62 | currency }}</div>
              </div>
              <div class="w-full flex justify-end text-zinc-500 text-sm">
                Atualizado
              </div>
              <div class="w-full flex items-center justify-between">
                <div class="text-zinc-700">Saldo no sistema</div>
                <div class="text-zinc-900 font-semibold">{{ 4987.43 | currency }}</div>
              </div>
              <div class="w-full flex justify-end text-zinc-500 text-sm">
                4 dias atras
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </app-card>
} @placeholder {
  <app-card>
    <div class="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-4">
      <div class="p-3 h-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-7 gap-4 col-span-1 md:col-span-2 2xl:col-span-4">
          @for (item of [0,1,2,3,4,5,6]; track item) {
            <p-skeleton height="6rem" />
          }
      </div>
      @for (item of [0,1,2,3]; track item) {
        <div class="col-span-1">
          <p-skeleton height="16rem" />
        </div>
      }
    </div>
  </app-card>
}

<p-dialog
  [(visible)]="dialogVisible"
  [maximizable]="true"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '52rem', minHeight: '32rem' }"
>
  <ng-template pTemplate="header">
    <div class="text-zinc-900 text-xl font-semibold">{{ dialogTitle() }}</div>
  </ng-template>
  <ng-container
    [ngTemplateOutlet]="selectedDialogChart()"
    [ngTemplateOutletContext]="{ inDialog: true }"
  ></ng-container>
</p-dialog>

<ng-template #financialMetrics let-inDialog="inDialog">
  <div class="border-b border-zinc-300 pb-2">
    <div class="text-sm text-zinc-500">Depósitos</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ financialDepositAndWithdrawMetricsData()?.deposits?.total | currency }}</div>
    <div class="text-sm text-zinc-500">
      @if ((financialDepositAndWithdrawMetricsData()?.deposits?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((financialDepositAndWithdrawMetricsData()?.deposits?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': financialDepositAndWithdrawMetricsData()?.deposits?.change_percentage,
        'text-rose-600': (financialDepositAndWithdrawMetricsData()?.deposits?.change_percentage || 0) < 0
      }">{{ (financialDepositAndWithdrawMetricsData()?.deposits?.change_percentage || 0) }}%</span>
    </div>
  </div>
  <div class="border-b border-zinc-300 pb-2">
    <div class="text-sm text-zinc-500">Saques</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ financialDepositAndWithdrawMetricsData()?.withdrawals?.total | currency }}</div>
    <div class="text-sm text-zinc-500">
      @if ((financialDepositAndWithdrawMetricsData()?.withdrawals?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((financialDepositAndWithdrawMetricsData()?.withdrawals?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': financialDepositAndWithdrawMetricsData()?.withdrawals?.change_percentage,
        'text-rose-600': (financialDepositAndWithdrawMetricsData()?.withdrawals?.change_percentage || 0) < 0
      }">{{ (financialDepositAndWithdrawMetricsData()?.withdrawals?.change_percentage || 0) }}%</span>
    </div>
  </div>
  <div class="border-b border-zinc-300 pb-2">
    <div class="text-sm text-zinc-500">Depósito Médio</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ financialDepositAndWithdrawMetricsData()?.avg_deposit?.value| currency }}</div>
    <div class="text-sm text-zinc-500">
      @if ((financialDepositAndWithdrawMetricsData()?.avg_deposit?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((financialDepositAndWithdrawMetricsData()?.avg_deposit?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': financialDepositAndWithdrawMetricsData()?.avg_deposit?.change_percentage,
        'text-rose-600': (financialDepositAndWithdrawMetricsData()?.avg_deposit?.change_percentage || 0) < 0
      }">{{ (financialDepositAndWithdrawMetricsData()?.avg_deposit?.change_percentage || 0) }}%</span>
    </div>
  </div>
  <div class="border-b border-zinc-300 pb-2">
    <div class="text-sm text-zinc-500">Saque Médio</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ financialDepositAndWithdrawMetricsData()?.avg_withdrawal?.value| currency }}</div>
    <div class="text-sm text-zinc-500">
      @if ((financialDepositAndWithdrawMetricsData()?.avg_withdrawal?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((financialDepositAndWithdrawMetricsData()?.avg_withdrawal?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': financialDepositAndWithdrawMetricsData()?.avg_withdrawal?.change_percentage,
        'text-rose-600': (financialDepositAndWithdrawMetricsData()?.avg_withdrawal?.change_percentage || 0) < 0
      }">{{ (financialDepositAndWithdrawMetricsData()?.avg_withdrawal?.change_percentage || 0) }}%</span>
    </div>
  </div>
  <!-- <div class="border-b border-zinc-300 pb-2">
    <div class="text-sm text-zinc-500">Custo de Bônus</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ 100000 | currency }}</div>
    <div class="text-sm text-zinc-500">
      @if (5 > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if (5 < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': 5 > 0,
        'text-rose-600': 5 < 0
      }">{{ .05 | percent }}</span>
    </div>
  </div> -->
  <div class="border-b border-zinc-300 pb-2">
    <div class="text-sm text-zinc-500">Qtd de Transações (Depósitos)</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ financialDepositAndWithdrawMetricsData()?.transactions?.deposits_count }}</div>
    <div class="text-sm text-zinc-500">
      @if ((financialDepositAndWithdrawMetricsData()?.transactions?.deposits_count_change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((financialDepositAndWithdrawMetricsData()?.transactions?.deposits_count_change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': financialDepositAndWithdrawMetricsData()?.transactions?.deposits_count_change_percentage,
        'text-rose-600': (financialDepositAndWithdrawMetricsData()?.transactions?.deposits_count_change_percentage || 0) < 0
      }">{{ (financialDepositAndWithdrawMetricsData()?.transactions?.deposits_count_change_percentage || 0) }}%</span>
    </div>
  </div>
  <div class="border-b border-zinc-300 pb-2">
    <div class="text-sm text-zinc-500">Qtd de Transações (Saques)</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ financialDepositAndWithdrawMetricsData()?.transactions?.withdrawals_count }}</div>
    <div class="text-sm text-zinc-500">
      @if ((financialDepositAndWithdrawMetricsData()?.transactions?.withdrawals_count_change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((financialDepositAndWithdrawMetricsData()?.transactions?.withdrawals_count_change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': financialDepositAndWithdrawMetricsData()?.transactions?.withdrawals_count_change_percentage,
        'text-rose-600': (financialDepositAndWithdrawMetricsData()?.transactions?.withdrawals_count_change_percentage || 0) < 0
      }">{{ (financialDepositAndWithdrawMetricsData()?.transactions?.withdrawals_count_change_percentage || 0) }}%</span>
    </div>
  </div>
  <div class="border-b border-zinc-300 pb-2">
    <div class="text-sm text-zinc-500">Net Deposit</div>
    <div class="text-xl text-zinc-900 font-semibold">{{ financialDepositAndWithdrawMetricsData()?.net_deposit?.value| currency }}</div>
    <div class="text-sm text-zinc-500">
      @if ((financialDepositAndWithdrawMetricsData()?.net_deposit?.change_percentage || 0) > 0) {
        <span><i class="fa-solid fa-arrow-up text-emerald-600"></i></span>
      } @else if ((financialDepositAndWithdrawMetricsData()?.net_deposit?.change_percentage || 0) < 0) {
        <span><i class="fa-solid fa-arrow-down text-rose-600"></i></span>
      }
      <span [ngClass]="{
        'text-emerald-600': financialDepositAndWithdrawMetricsData()?.net_deposit?.change_percentage,
        'text-rose-600': (financialDepositAndWithdrawMetricsData()?.net_deposit?.change_percentage || 0) < 0
      }">{{ (financialDepositAndWithdrawMetricsData()?.net_deposit?.change_percentage || 0) }}%</span>
    </div>
  </div>
</ng-template>

<ng-template #financialInOut let-inDialog="inDialog">
  <div class="flex flex-wrap items-start justify-between">
    <div>
      <div class="text-zinc-800 text-sm">Entradas e Saídas</div>
      <div class="text-zinc-900 text-lg font-semibold">{{ (financialInOutData() ? financialInOutData()!.total_entradas - financialInOutData()!.total_saidas : 0) | currency}}</div>
      <div class="text-zinc-800 text-xs">Valor em caixa</div>
    </div>
    <div class="flex flex-col items-end justify-start gap-2">
      @if (!inDialog) {
        <i class="fa-solid fa-expand cursor-pointer" (click)="openDialog(financialInOut, 'Entradas e Saídas')"></i>
      }
    </div>
  </div>

  <div class="mt-4">
    @if (financialInOutLoading() && !financialInOutChartData()) {
      <div class="w-full h-56 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else if (financialInOutChartData()?.datasets.length) {
      <div class="w-full items-center justify-center">
        <p-chart
          type="bar"
          id="financialInOutChart"
          #financialInOutChart
          [data]="financialInOutChartData()"
          [options]="financialInOutOptions()"
          class="w-full"
          [ngClass]="{ 'h-100': inDialog, 'h-56': !inDialog }"
        />
      </div>
    } @else {
      <app-empty-chart />
    }
  </div>
</ng-template>

<ng-template #financialByCategory let-inDialog="inDialog">
  <div class="flex flex-wrap items-start justify-between">
    <div>
      <div class="text-zinc-800 text-sm">Gastos por Categoria</div>
      <div class="text-zinc-900 text-lg font-semibold">{{ financialByCategoryData()?.total | currency}}</div>
    </div>
    <div class="flex flex-col items-end justify-start gap-2">
      @if (!inDialog) {
        <i class="fa-solid fa-expand cursor-pointer" (click)="openDialog(financialByCategory, 'Gastos por Categoria')"></i>
      }
    </div>
  </div>

  <div class="mt-4">
    @if (financialByCategoryLoading() && !financialByCategoryChartData()) {
      <div class="w-full h-56 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else if (financialByCategoryChartData()?.datasets.length) {
      <div class="w-full flex items-center justify-center">
        <!-- <p-chart
          type="doughnut"
          [data]="financialByCategoryChartData()"
          [options]="financialByCategoryOptions()"
          class="w-full"
          [ngClass]="{ 'h-100': inDialog, 'h-56': !inDialog }"
        /> -->
      <p-chart
        type="bar"
        id="summaryGgrDetailsWeeklyChart"
        #summaryGgrDetailsWeeklyChart
        [data]="financialByCategoryChartData()"
        [options]="financialByCategoryOptions()"
        class="w-full"
        [ngClass]="{ 'h-100': inDialog, 'h-48': !inDialog }"
      />
      </div>
    } @else {
      <app-empty-chart />
    }
  </div>
</ng-template>

<ng-template #financialInvoices let-inDialog="inDialog">
  <div class="flex flex-wrap items-start justify-between">
    <div class="text-zinc-800 text-sm">Faturas</div>
  </div>
  @if (financialInvoicesLoading()) {
    <div class="w-full h-56 flex items-center justify-center">
      <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
    </div>
  } @else {
    <div class="w-full h-full flex flex-col align-start justify-center gap-2 pb-4">
      @if (financialInvoicesData()?.outstanding?.total !== 0 || financialInvoicesData()?.paid?.total !== 0) {
        @if (financialInvoicesData()?.outstanding?.total !== 0) {
          <div class="w-full text-sm text-zinc-900">
            {{ financialInvoicesData()?.outstanding?.total | currency }} ainda não pagos
          </div>
          <div class="w-full flex flex-wrap items-center justify-between">
            <div class="text-zinc-900 font-semibold">
              {{ financialInvoicesData()?.outstanding?.in_day | currency }}
            </div>
            <div class="text-zinc-900 font-semibold">
              {{ financialInvoicesData()?.outstanding?.overdue | currency }}
            </div>
          </div>
          <div class="w-full flex flex-wrap items-center justify-between">
            <div class="text-zinc-500 text-sm">
              Atrasado
            </div>
            <div class="text-zinc-500 text-sm">
              Em dia
            </div>
          </div>
          <div class="w-full">
            <app-simple-horizontal-bar [data]="financialInvoicesOutgoingChartData()" />
          </div>
        }
        @if (financialInvoicesData()?.paid?.total !== 0) {
          <div class="w-full text-sm text-zinc-900">
            {{ financialInvoicesData()?.paid?.total | currency }} pagos
          </div>
          <div class="w-full flex flex-wrap items-center justify-between">
            <div class="text-zinc-900 font-semibold">
              {{ financialInvoicesData()?.paid?.deposited | currency }}
            </div>
            <div class="text-zinc-900 font-semibold">
              {{ financialInvoicesData()?.paid?.not_deposited | currency }}
            </div>
          </div>
          <div class="w-full flex flex-wrap items-center justify-between">
            <div class="text-zinc-500 text-sm">
              Depositado
            </div>
            <div class="text-zinc-500 text-sm">
              Não depositado
            </div>
          </div>
          <div class="w-full">
            <app-simple-horizontal-bar [data]="financialInvoicesPaidChartData()" />
          </div>
        }
      } @else {
        <app-empty-chart />
      }
    </div>
  }
</ng-template>

<ng-template #financialProfitExpenses let-inDialog="inDialog">
  @if (financialProfitExpensesLoading() && !financialProfitExpensesData()) {
    <div class="flex flex-wrap items-start justify-between">
      <div>
        <div class="text-zinc-800 text-sm">Resultados 2</div>
      </div>
    </div>
    <div class="w-full h-56 flex items-center justify-center">
      <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
    </div>
  } @else if (financialProfitExpensesData()) {
    <div class="flex flex-wrap items-start justify-between">
      <div>
        <div class="text-zinc-800 text-sm">Resultados</div>
        <div class="text-zinc-900 text-lg font-semibold">{{ financialProfitExpensesData()?.lucro_liquido?.value | currency}}</div>
      </div>
    </div>
    <p-divider />
    <div class="w-full flex flex-col items-start justify-center">
      <div class="w-full flex align-center justify-between">
        <div class="text-xl font-semibold text-zinc-900">{{ financialProfitExpensesData()?.receita_bruta?.value | currency }}</div>
      </div>
      <div class="w-full">
        <p-chart
          type="bar"
          id="financialProfitChart"
          #financialProfitChart
          [data]="financialProfitChartData()"
          [options]="financialProfitOptions()"
          class="w-full h-16"
        />
      </div>
      <div class="w-full flex align-center justify-between mt-4">
        <div class="text-xl font-semibold text-zinc-900">{{ financialProfitExpensesData()?.despesas?.value | currency }}</div>
      </div>
      <div class="w-full">
        <p-chart
          type="bar"
          id="financialExpensesChart"
          #financialExpensesChart
          [data]="financialExpensesChartData()"
          [options]="financialExpensesOptions()"
          class="w-full h-16"
        />
      </div>
    </div>
  } @else {
    <div class="flex flex-wrap items-start justify-between">
      <div>
        <div class="text-zinc-800 text-sm">Resultados</div>
      </div>
    </div>
    <app-empty-chart />
  }
</ng-template>
